import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  // BehaviorSubject guarda el estado del loader y permite suscribirse
  private _loading = new BehaviorSubject<boolean>(false);

  // Observable público para que los componentes se suscriban
  public loading$ = this._loading.asObservable();

  constructor() { }

  // Método para cambiar el estado del loader
  setLoading(loading: boolean) {
    this._loading.next(loading);
  }
}
